import type { ReactNode } from 'react';
import { signOut } from 'firebase/auth';
import {
  AppBar,
  Box,
  Button,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import { auth } from './firebase';

const NAV = [
  { to: '/jobs', label: 'New jobs' },
  { to: '/production', label: 'In production' },
  { to: '/dispatch', label: 'Ready to dispatch' },
  { to: '/dispatched', label: 'Dispatched' },
  { to: '/settlements', label: 'Settlements' },
  { to: '/print-lab', label: 'Print lab' },
];

const DRAWER_WIDTH = 220;

export function Shell({ children }: { children: ReactNode }) {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
      <AppBar
        position="fixed"
        color="inherit"
        sx={{ zIndex: (t) => t.zIndex.drawer + 1, borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Toolbar sx={{ gap: 2 }}>
          <Typography variant="h6" sx={{ flexGrow: 1, fontSize: '1rem', fontWeight: 700 }}>
            EPrintSmart Vendor
          </Typography>
          <Button size="small" onClick={() => signOut(auth)}>
            Sign out
          </Button>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        sx={{
          width: DRAWER_WIDTH,
          flexShrink: 0,
          '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box' },
        }}
      >
        <Toolbar />
        <List sx={{ px: 1 }}>
          {NAV.map((item) => (
            <ListItemButton
              key={item.to}
              component={NavLink}
              to={item.to}
              selected={location.pathname.startsWith(item.to)}
              sx={{ borderRadius: 1.5, mb: 0.25 }}
            >
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '0.9rem' }} />
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1, p: 3, bgcolor: 'background.default' }}>
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}
